module.exports = __webpack_public_path__ + "img/student.a0fac20b.svg";